import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg dark:prose-invert">
            <p className="text-muted-foreground mb-6">
              Last updated: {new Date().toLocaleDateString()}
            </p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
                <p className="text-muted-foreground">
                  Arrow Drop Foundation ("we," "our," or "us") is committed to protecting your privacy. 
                  This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
                  when you interact with our organization, website, or services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
                <p className="text-muted-foreground mb-4">We may collect the following types of information:</p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Personal identification information (Name, email address, phone number)</li>
                  <li>Demographic information</li>
                  <li>Donation and transaction information</li>
                  <li>Volunteer registration information</li>
                  <li>Website usage data</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
                <p className="text-muted-foreground mb-4">We use the collected information for:</p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Processing donations and maintaining records</li>
                  <li>Communicating about our programs and initiatives</li>
                  <li>Responding to inquiries and providing support</li>
                  <li>Improving our services and website</li>
                  <li>Complying with legal obligations</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">4. Information Sharing</h2>
                <p className="text-muted-foreground">
                  We do not sell, trade, or rent your personal information to third parties. 
                  We may share information with trusted partners who assist us in operating our 
                  website, conducting our business, or serving our users, so long as those parties 
                  agree to keep this information confidential.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">5. Data Security</h2>
                <p className="text-muted-foreground">
                  We implement appropriate security measures to protect your personal information. 
                  However, no method of transmission over the internet or electronic storage is 
                  100% secure, and we cannot guarantee absolute security.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
                <p className="text-muted-foreground mb-4">You have the right to:</p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Access your personal information</li>
                  <li>Correct inaccurate information</li>
                  <li>Request deletion of your information</li>
                  <li>Opt-out of communications</li>
                  <li>File a complaint with relevant authorities</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold mb-4">7. Contact Us</h2>
                <p className="text-muted-foreground">
                  For any questions about this Privacy Policy, please contact us at:<br />
                  Email: arrowdropfoundation@gmail.com<br />
                  Phone: +91 9698862115<br />
                  Address: 1/71 B, Perfect Garden, Andakkapalayam, Vellanipatti Post, 
                  Coimbatore, Tamil Nadu-641048
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;